<template>
  <div>
    <section style="margin-left: 20px; margin-top: 10px">
      <div class="box box-solid">
        <div class="box-body">
          <div class="d-flex flex-column mb-2">
            <button
              @click.prevent="onSubmit()"
              class="btn btn-danger btn-md btn-block"
            >
              <i class="fa fa-calendar"></i> Create Schedule
            </button>
            <span class="error-message" v-if="this.hasError"
              >Error: All Fields must be selected</span
            >
          </div>

          <form role="form" @input="resetError" @change="resetError">
            <div class="row">
              <div class="col-md-12">
                <div class="input-group">
                  <Datepicker
                    v-model="config.startDate"
                    id="startDate"
                    placeholder="start date"
                    format="yyyy-MM-dd"
                    :input-class="'form-control'"
                    :calendar-button="true"
                    :calendar-button-icon="'fa fa-calendar'"
                    :disabled-dates="disabledDates"
                  ></Datepicker>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label text-primary">
                Email
                <i
                  class="fas fa-info-circle"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="Choose email that you want the report to be sent to."
                ></i>
              </label>
              <input
                type="email"
                v-model="config.email"
                class="form-control"
                :placeholder="this.loggedInUser.username"
              />
            </div>
            <div class="form-group">
              <label class="control-label text-primary"
                >Schedule Email Period</label
              >
              <br />
              <input
                type="radio"
                id="scheduleMonthly"
                value="monthly"
                v-model="config.schedulePeriod"
              />
              Monthly
              <span>&nbsp;&nbsp;&nbsp;</span>
              <input
                type="radio"
                id="scheduleYearly"
                value="yearly"
                v-model="config.schedulePeriod"
              />
              Yearly
            </div>
            <div class="form-group">
              <label class="control-label text-primary">Partner Type</label>
              <br />
              <input
                type="radio"
                id="partnerTair"
                value="tair"
                v-model="config.partnerType"
              />
              TAIR
              <span>&nbsp;&nbsp;&nbsp;</span>
              <input
                type="radio"
                id="partnerRep"
                value="repbase"
                v-model="config.partnerType"
              />
              Repbase
              <span>&nbsp;&nbsp;&nbsp;</span>
              <input
                type="radio"
                id="partnerMor"
                value="morphobank"
                v-model="config.partnerType"
              />
              Morphobank
            </div>
            <div class="form-group">
              <label class="control-label text-primary">Institution</label>
              <br />
              <div class="nav-tabs-custom">
                <div class="tab-content">
                  <div class="tab-pane active" id="tab_1">
                    <Institution
                      :filteredNames="filteredNames"
                      @rowClicked="config.selectedParty = $event"
                    ></Institution>
                  </div>
                  <div class="tab-pane" id="tab_2">
                    <!-- <Consortium
                      @rowClicked="config.selectedParty = $event"
                    ></Consortium> -->
                  </div>
                </div>
              </div>
            </div>

            <hr style="border: 0.5px solid #efefef" />
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Institution from "./sections/Institution";
import Datepicker from "vuejs-datepicker";

import $ from "jquery";
import "bootstrap";

export default {
  data() {
    return {
      config: {
        startDate: "",
        schedulePeriod: "",
        // institutionName: "",
        partnerType: "",
        partyType: "organization",
        selectedParty: "",
        selectedPartyName: "",
        ipRange: "",
        email: "",
      },
      filteredNames: [],
      hasError: false,
      allOrgs: [],
    };
  },
  components: {
    Institution: Institution,
    Datepicker: Datepicker,
  },
  created() {
    if (this.loggedInUser) {
      this.config.email = this.loggedInUser.username;
    }
  },
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    disabledDates() {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      return {
        to: tomorrow,
        customPredictor: (date) => date.getDate() < 15,
      };
    },
  },
  watch: {
    $route: "fetchData",
    loggedInUser(newVal, oldVal) {
      console.log("loggedInUser", newVal);
    },
  },
  methods: {
    datesDisabled(date) {
      return date.getDate() < 15;
    },
    fetchData() {},
    resetError() {
      this.hasError = false;
    },
    onSubmit() {
      this.hasError = false;
      // console.log(this.config);
      if (
        !this.config.selectedParty ||
        !this.config.partnerType ||
        !this.config.schedulePeriod ||
        !this.config.email
      ) {
        this.hasError = true;
        return;
      }
      let today = new Date();
      let tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      const payload = {
        scheduler: this.loggedInUser.username,
        startDate: this.config.startDate,
        schedulePeriod: this.config.schedulePeriod,
        partnerType: this.config.partnerType,
        partyType: this.config.partyType,
        selectedParty: this.config.selectedParty.partyId,
        // ipRange: this.config.ipRange,
        selectedPartyName: this.config.selectedParty.name,
        email: this.config.email,
      };
      const requiredFields = [
        "scheduler",
        "startDate",
        "schedulePeriod",
        "partnerType",
        "partyType",
        "selectedParty",
        "selectedPartyName",
        "email",
      ];

      requiredFields.forEach((field) => {
        if (!payload[field]) {
          console.error(`Error: ${field} cannot be null or empty.`);
          hasError = true;
        }
      });

      if (!this.hasError) {
        this.onAddSchedule(payload);
      } else {
        // Show an error message to the user
        // alert(
        //   "Error! Please make sure to select all required fields. If that does not work, please log out and log back in"
        // );
      }
    },
    onAddSchedule(payload) {
      this.$store
        .dispatch("schedule/addSchedule", payload)
        .then(() => {
          this.$store.dispatch("schedule/setScheduleData");
          alert("Successfully Added Schedule");
        })
        .catch((error) => {
          // Handle error
          console.error("Error submitting schedule:", error);
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
};
</script>

<style scoped>
.error-message {
  border: 1px dashed red; /* Add the desired border style and color */
  text-align: center; /* Center the text horizontally */
  padding: 10px; /* Add padding for spacing */
  margin-top: 10px; /* Add margin for spacing */
  color: red;
  margin-bottom: 10px;
}
.form-control {
  background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/paywall/usage/ScheduleConfig.vue